import { render, staticRenderFns } from "./LoanHistory.vue?vue&type=template&id=32bf1030&"
import script from "./LoanHistory.vue?vue&type=script&lang=js&"
export * from "./LoanHistory.vue?vue&type=script&lang=js&"
import style0 from "./LoanHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports